import { createFileRoute, redirect } from '@tanstack/react-router'
// import { encountersQueryOptions } from '~/features/dashboard/pages/encounters/api/queries'
import { paymentsQueryOptions } from '~/features/dashboard/pages/encounters/api/queries/payment'
import { paymentsLinkOptions } from '~/features/dashboard/pages/payments/pages'

export const Route = createFileRoute('/(dashboard)/dashboard/$program/payments/')({
  loader: ({ context }) => {
    context.queryClient.ensureQueryData(paymentsQueryOptions({
      limit: 10,
      skip: 0
    }))
    context.queryClient.ensureQueryData(paymentsQueryOptions({
      type: "appointment",
      limit: 10,
      skip: 0
    }))
    context.queryClient.ensureQueryData(paymentsQueryOptions({
      type: "refill",
      limit: 10,
      skip: 0
    }))
  },
  beforeLoad: ({ params }) => {
    throw redirect(paymentsLinkOptions(params.program))
  },
  errorComponent: ({ error }: { error: Error }) => (
    <div
      role="alert"
      className="flex min-h-screen items-center justify-center p-4"
    >
      <div className="text-center">
        <h1 className="text-2xl font-bold">Error Loading Payments Page</h1>
        <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  ),
})

